<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap5">Part Two<br/>Kitten</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10chap5.vue?00d811fc